var exports = {
  "kL": "PiPOverlay.module__container___emVRQ1",
  "n_": "PiPOverlay.module__hoverOverlay___emVRQ1",
  "YQ": "PiPOverlay.module__containerInteractionActive___emVRQ1",
  "YL": "PiPOverlay.module__headerGradient___emVRQ1",
  "VW": "PiPOverlay.module__headerContent___emVRQ1",
  "LD": "PiPOverlay.module__headerLeft___emVRQ1",
  "q3": "PiPOverlay.module__returnToCallButton___emVRQ1",
  "fs": "PiPOverlay.module__returnToCallIcon___emVRQ1",
  "Qt": "PiPOverlay.module__returnToCallLabel___emVRQ1",
  "wY": "PiPOverlay.module__footerGradient___emVRQ1",
  "z8": "PiPOverlay.module__footerContent___emVRQ1",
  "PU": "PiPOverlay.module__footerLeft___emVRQ1",
  "zz": "PiPOverlay.module__streamerName___emVRQ1",
  "wV": "PiPOverlay.module__footerRight___emVRQ1",
  "ti": "PiPOverlay.module__spectatorBadge___emVRQ1",
  "Bh": "PiPOverlay.module__spectatorIcon___emVRQ1",
  "hP": "PiPOverlay.module__actionButton___emVRQ1",
  "P4": "PiPOverlay.module__disconnectButton___emVRQ1",
  "gE": "PiPOverlay.module__actionIcon___emVRQ1",
};

module.exports = exports;
